import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-04-14'
        tag='eBay'
        title='Navigating eBay taxes: The basics to get you started'
      >
        <p>
          Taxes, in general, are an intimidating, complex topic. More so for a seller running a business on a virtual
          marketplace such as eBay. But no matter how unpleasant the topic of taxes is, it is inevitable to deal with it
          as a law-abiding citizen and a compliant member of the eBay community.
        </p>
        <p>
          There’s a lot to cover, and it can be quite overwhelming, so let’s break down the subject into digestible
          chunks. However, as this is only a primer, it is best to consult a tax expert for your specific concerns,
          especially if selling on eBay is your bread and butter and not just an occasional side hustle.
        </p>

        <p>Goods purchased on eBay usually entail applicable tax laws and obligations, such as the following:</p>
        <ul>
          <li>Sales Tax (US)</li>
          <li>Internet Sales Tax (currently imposed by 46 US jurisdictions)</li>
          <li>Goods and Services Tax (GST) or Value Added Tax (VAT) (UK, AU, European Union)</li>
          <li>Income Tax</li>
          <li>Shipping and handling (in certain areas)</li>
          <li>Import charges (non-US buyers)</li>
        </ul>

        <p>
          The main confusion lies in the different tax rules and rates imposed by states and countries. There’s no
          one-size-fits-all template to follow. Depending on the type of tax, eBay may use basis factors such as the
          seller’s location and buyer’s shipping address to determine the taxes to charge and the tax rate and who
          should collect and remit.
        </p>
        <p>
          In the case of sales tax, eBay automatically adds this to the amount of item before checkout if the buyer is
          located in a state wherein eBay is legally obliged to do the collection. Otherwise, you must set up a tax
          table that will apply to your listings as needed. eBay will then add the applicable sales tax to the total
          amount upon checkout. It is crucial to collect the right amount and remit whatever was collected on your end.
        </p>

        <h3>What tax-related responsibilities do I have as a seller?</h3>
        <p>
          As a seller, you are expected to do your research and be knowledgeable enough to know how much sales tax to
          collect (if eBay doesn’t automatically factor it in before check out) and validate what kind of tax was
          collected on certain sales transactions. You also need to give overseas buyers a heads up on import charges.
        </p>
        <p>
          It is also your responsibility as a seller to report and pay income tax for eBay sales exceeding the threshold
          of what could be considered a mere hobby or casual selling of items for less than what you originally paid for
          them.
        </p>
        <p>
          Aside from income tax, the eBay tax policy also states that paying consumption taxes such as VAT and GST is
          part of a seller’s responsibility. This may be automatically added to your selling fees if eBay is legally
          permitted to collect such tax where you are based.
        </p>
        <p>
          It is important to ensure that your location is updated and that your tax obligations are taken care of for
          compliance and auditing purposes. If requested, eBay is legally bound to share information about your sales
          transactions with government authorities.
        </p>
        <p>
          Note that misdeclaration or falsification will face corresponding consequences, ranging from reduction of
          seller ratings to account suspension on eBay.
        </p>

        <h3>When do sellers receive Tax Form 1099-K?</h3>
        <p>
          Since the start of this year, online marketplaces, including eBay, have been mandated by law to automatically
          issue Form 1099-K to sellers earning at least $600 in sales.
        </p>
        <p>
          This tax reporting document captures the gross amount of all transactions using eBay Managed Payments done in
          a given calendar year. You will receive this form if your sales reach the IRS reporting threshold of $600,
          excluding adjustments like refunds, fees, credits, and discounts.
        </p>
        <p>
          Note that since you will be taxed on your net income and not on your gross income, do not be intimidated by
          the amount reflected on the form. You only owe taxes for items that generated profit or sold for more than you
          originally paid for.
        </p>
        <p>
          To see if you have been issued Form 1099-K for the previous tax year, check Seller Hub or My eBay every
          January. It should be ready to download by then. As this is a new requirement, this form will be available in
          January 2023 for payment transactions done in 2022.
        </p>

        <h3>How does sales tax work in case of a refund?</h3>
        <p>
          Once a buyer’s refund request is accepted (whether it’s a partial or full refund), eBay will return to the
          buyer the amount paid for the item plus the sales tax collected if it was processed on the platform.
        </p>
        <p>
          If it’s through PayPal, it is the seller’s responsibility to return the amount paid by the buyer upon
          checkout, which may include Internet Sales Tax. eBay will consequently credit back to the seller the amount
          refunded to the buyer.
        </p>
        <p>
          Being tax compliant can be such a hassle, but the peace of mind that comes with it makes any inconveniences
          worth it. It is just one of the aspects that any responsible eBay seller must accomplish in running a
          reputable business on the platform. Consider subscribing to tax filing tools or getting the services of an
          accountant, if you don’t have one already, to stay on top of your tax-related concerns.
        </p>
        <p>
          While you’re at it, it also helps to explore tools that help you improve your processes and increase your
          productivity. There’s OneShop, an all-in-one app that lets you crosslist to Mercari and Poshmark.{' '}
          <a href='https://tools.oneshop.com/signup'>Sign up for a free 7-day trial</a> to experience its benefits
          today.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
